import { Dispatch, SetStateAction, useState } from "react";
import TabFilters from "../../../../atoms/tabs-selector";
import { agendaTabOptions } from "./helper";


type Props = {
    setAgendaTab: Dispatch<SetStateAction<any>>;
    agendaTab: string;
}

export default function AgendaTabs({agendaTab, setAgendaTab}: Props) {

    return (
        <>
           <TabFilters
                onChange={(s: string) => {
                    s && setAgendaTab(s);
                }}
                value={agendaTab}
                options={agendaTabOptions}
            />
        </>
    )
}